import { NotificationProvider } from "@/shared/notification/NotificationContext";
import { PropsWithChildren } from "react";
import { DrawerProvider } from "./providers/DrawerProvider/provider";

export const AppProviders = ({ children }: PropsWithChildren) => {
  return (
    <NotificationProvider>
      <DrawerProvider>{children}</DrawerProvider>
    </NotificationProvider>
  );
};
